export default {
    bindings: {
        isGlobal: '<',
        isStatistics: '<',
    },
    controller: 'dashboardController',
    template: require('../views/statistics.dashboard.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/dashboard/components/statistics.dashboard.component.js